import gtmService from '@/shared/tracking/gtm.service';
import { ProductSpotModel } from '@/types/productServerApi';
import { TempSearchViewModel } from '@/shared/search/temp-search-api';

export default function useSearchTracking() {
    const newSearchResult = (term: string, result: TempSearchViewModel) => {
        if (!!term && !!result) {
            gtmService.searchPage(term, result.products.total ?? 0);
        }
    };

    const clickedSearchResultProduct = (term: string, product: ProductSpotModel) => {
        gtmService.searchResultProduct(term, product.name);
    };

    return {
        newSearchResult,
        clickedSearchResultProduct,
    };
}
